import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import plus from "../../../Components/assets/icons/a1.png";
import colunms from "../../../Components/assets/icons/LINES.png";
import search1 from "../../../Components/assets/icons/search.png";
import top from "../../../Components/assets/icons/top.png";
import Table from "react-bootstrap/Table";
import { Link } from "react-router-dom";
import Header from "../../Header/Header";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faDownload, fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import toast, { Toaster } from "react-hot-toast";
// import AddOffCanvance from "./Add";
// import EditOffCanvance from "./Edit";
import ModalDelete from "../../common/ModelDelete";
import Select from "react-select";
import ModelBulkUpload from "../../common/ModelBulkUpload";
import { AddButton, EditButton, DeletButton } from "../../common/Button";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";

import { Button } from "react-bootstrap";
import OffcanvasCon from "../../OffcanvasCon/OffcanvasCon";
import DataTable from "datatables.net";
import parse from "html-react-parser";
import Pagination_Holder from "../../common/Pagination_Holder/Pagination_Holder";
import Pagination from "react-bootstrap/Pagination";
import { Select2Data } from "../../../utils/api";
library.add(fas);

const Tables = () => {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    Per_Page_Dropdown,
    postData,
    getDownloadDataExcel,
    IMG_URL,
    isAllow,
    SelectUsers,
  } = useContext(Context);
  const [onPageChange, setonPageChange] = useState(1);

  const [totalPages, settotalPages] = useState();

  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };

  const paginationItems = [];
  for (let page = 1; page <= totalPages; page++) {
    paginationItems.push(
      <Pagination.Item
        key={page}
        active={page === onPageChange}
        onClick={() => handlePageChange(page)}
      >
        {page}
      </Pagination.Item>
    );
  }

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(5);
  const [search, setSearch] = useState("");
  const [reset, setReset] = useState();
  const [show, setShowAdd] = useState(false);
  const [show1, setShowEdit] = useState(0);
  const [changeStatus, setChangeStatus] = useState();
  const [option, setOption] = useState();
  const [showoff, setShowoff] = useState(false);

  const [customerName, setCustomerName] = useState("");
  const [paymentMode, setPaymentMode] = useState("");
  const [searchOrderStatus, setSearchOrderStatus] = useState("");

  const getDataAll = async () => {
    const response = await getData(
      `/transaction-data/order-transaction-history?page=${onPageChange}&per_page=${perPage}&term=${search}&searchCustomer=${
        customerName?.value || ""
      }&paymentMode=${paymentMode?.value || ""}&searchOrderStatus=${
        searchOrderStatus?.value || ""
      }`
    );
    await setData(response);
    setCurrentPage(response?.data?.currentPage);
    setperPage(response?.data?.per_page);
    setSearch(response?.data?.search_name);
    settotalPages(response?.data?.totalPages);

    setOption(await Per_Page_Dropdown(response?.data?.totalEntries));

    const newData = response?.data?.data;
    if (newData) {
      const newIds = newData.map((d) => d?.id);
      setAllChecked(newIds);
    }
  };

  useEffect(() => {
    getDataAll();
  }, [
    changeStatus,
    perPage,
    reset,
    show,
    show1,
    customerName,
    paymentMode,
    onPageChange,
    search,
    searchOrderStatus,
  ]);

  const [customer, setCustomer] = useState({});
  const GetAllCustomers = async () => {
    const response = await getData("/all-customer");

    if (response?.success) {
      setCustomer(await SelectUsers(response?.data, "customer_id"));
    }
  };

  const [orderStatus, setOrderStatus] = useState({});
  const GetAllOrderStatus = async () => {
    const response = await getData("/all-order-status");

    if (response?.success) {
      setOrderStatus(await Select2Data(response?.data, "order_id"));
    }
  };

  useEffect(() => {
    GetAllCustomers();
    GetAllOrderStatus();
  }, []);

  const payment = [
    {
      value: "COD",
      label: "COD",
    },
    {
      value: "Online",
      label: "Online",
    },
    {
      value: "Wallet",
      label: "Wallet",
    },
  ];

  const ChangeStatus = async (id) => {
    const response = await editStatusData(
      `/transaction-data/order-transaction-history/${id}`
    );
    setChangeStatus(response);
  };

  // Modal function
  const handleClose = () => setShowAdd(false);
  const handleShow = () => setShowAdd(true);

  const handleClose1 = () => setShowEdit(0);
  const handleShow1 = (id) => {
    setShowEdit(id);
  };

  // Select All Functionality
  const [selectAllChecked, setSelectAllChecked] = useState([]);
  const [allChecked, setAllChecked] = useState([]);

  const handleSelectAll = async () => {
    await setSelectAllChecked(allChecked);
  };

  const handleChange = async (e) => {
    const { value, checked } = e.target;

    if (value === "selectAll") {
      if (checked) {
        handleSelectAll();
      } else {
        await setSelectAllChecked([]);
      }
    } else {
      if (checked) {
        await setSelectAllChecked([...selectAllChecked, Number(value)]);
      } else {
        await setSelectAllChecked(
          selectAllChecked.filter((e) => e !== Number(value))
        );
      }
    }
  };

  // Delete module
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [recordToDeleteName, setRecordToDeleteName] = useState(null);

  const showDeleteRecord = async (id, name) => {
    setShowDeleteModal(true);
    setRecordToDeleteId(id);
    setRecordToDeleteName(name);
  };

  const handleDeleteRecord = async () => {
    setShowDeleteModal(false);
    if (recordToDeleteId) {
      const response = await deleteData(
        `/transaction-data/order-transaction-history/${recordToDeleteId}`
      );
      // notify("error", "Deleted Succefully");

      ErrorNotify(recordToDeleteName);

      setRecordToDeleteId(null);
      setRecordToDeleteName(null);
      setChangeStatus(response);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setRecordToDeleteId(null);
    setRecordToDeleteName(null);
  };

  //  column hide and show.....
  const [visible, setVisibel] = useState({
    col0: true,
    col1: true,
    col2: true,
    col3: true,
    col4: true,
    col5: true,
    col6: true,
    col7: true,
    col8: true,
    col9: true,
    col10: true,
    col11: true,
  });

  //toggle columnns.........
  const toggleColumn = (event, columnName) => {
    event.preventDefault();
    setVisibel((prev) => ({
      ...prev,
      [columnName]: !prev[columnName],
    }));
  };

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const BulkUpload = async (e) => {
    try {
      const formData = new FormData();
      formData.append("file", e.target.files[0]);
      const response = await postData("/delivery-boy/bulk", formData, {});
      if (response?.success) {
        setShowModal({ code: response.code, message: response.message });
      } else {
        setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        setShowoff(response?.data);
      }, 1000);
      getDataAll();
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  const Sample = async (e) => {
    try {
      await getDownloadDataExcel("/delivery-boy/sample", {}, "Category");
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  useEffect(() => {
    const table = new DataTable("#example");
    return () => {
      table.destroy();
    };
  }, []);

  const HandleDownload = async () => {
    if (selectAllChecked.length == 0) {
      alert("Please Select Atleast One Record");
    } else {
      try {
        await getDownloadDataExcel(
          "/transaction-data/order-transaction-history/download",
          selectAllChecked,
          "Order Transaction List"
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  return (
    <>
      <div className="main-advancedashboard">
        <Header
          title={"Order Transaction History"}
          link={"/transaction-data/order-transaction-history"}
        />
        <section className="AdvanceDashboard">
          <div className="row">
            <div className="col-lg-12">
              <div className="row MainRowsec">
                <section className="Tabels tab-radio tab-radio mt-3">
                  <div className="">
                    {/* container */}
                    <div className="row">
                      {/* <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 mt-lg-0 mt-2">
                        <div className="add">
                          {isAllow?.includes(242) ? (
                            <Link
                              // to="/delivery-boy/add"
                              type="button"
                              className="btn btn-add pe-3"
                            >
                              <div onClick={() => handleShow()}>
                                <img
                                  src={plus}
                                  className="plus me-2 ms-0"
                                  alt=""
                                />
                                Add Subscription History
                              </div>
                            </Link>
                          ) : (
                            <></>
                          )}
                        </div>
                      </div> */}

                      <div className="border-line my-3"></div>
                      <div className="row ">
                        <div className=" col-12"></div>
                        <div className=" col-12">
                          <div className="row align-items-end">
                            <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-6 col-12 mb-2">
                              <div className="num me-2">
                                <input
                                  placeholder="Search By Invoice/Amount"
                                  type="text"
                                  className="form-control"
                                  id=""
                                  value={search}
                                  onChange={(e) => {
                                    setSearch(e.target.value);
                                    handlePageChange(1);
                                  }}
                                />
                              </div>
                            </div>

                            <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-6 col-12 mb-2">
                              <div
                                className="num Subscription History me-3
"
                              >
                                <Select
                                  options={customer}
                                  placeholder="Sort By Customer"
                                  value={customerName}
                                  onChange={(e) => {
                                    setCustomerName(e);
                                    handlePageChange(1);
                                  }}
                                />
                              </div>
                            </div>

                            <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-6 col-12 mb-2">
                              <div
                                className="num Subscription History me-3
"
                              >
                                <Select
                                  options={payment}
                                  placeholder="Sort By paymentMode"
                                  value={paymentMode}
                                  onChange={(e) => {
                                    setPaymentMode(e);
                                    handlePageChange(1);
                                  }}
                                />
                              </div>
                            </div>

                            <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-6 col-12 mb-2">
                              <div
                                className="num Subscription History me-3
"
                              >
                                <Select
                                  options={orderStatus}
                                  placeholder="Sort By Order Status"
                                  value={searchOrderStatus}
                                  onChange={(e) => {
                                    setSearchOrderStatus(e);
                                    handlePageChange(1);
                                  }}
                                />
                              </div>
                            </div>

                            {/* <div className="col-xxl-1 col-xl-2  col-lg-2  col-md-2 col-12 mb-2">
                              <div className="Search me-2">
                                <Button
                                  type="button"
                                  onClick={getDataAll}
                                  className="btn btn-search btn btn-primary w-100"
                                >
                                  <img
                                    src={search1}
                                    className="search"
                                    alt=""
                                  />
                                </Button>
                              </div>
                            </div> */}
                            <div className="col-xxl-1 col-xl-2  col-lg-2  col-md-2 col-12 mb-2">
                              <div className="Search-1">
                                <button
                                  type="button"
                                  onClick={() => {
                                    setSearch("");
                                    setCustomerName("");
                                    setPaymentMode("");
                                    setSearchOrderStatus("");
                                    setReset(!reset);
                                  }}
                                  className="btn btn-reset w-100"
                                >
                                  Reset
                                </button>
                              </div>
                            </div>
                            <div className="col-xxl-2 col-xl-3 col-lg-4 col-md-6 col-12 mb-2">
                              <button
                                className="btn btn-success "
                                onClick={HandleDownload}
                              ><FontAwesomeIcon className="me-1" icon={faDownload} />Downlaod Excel
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="border-line my-3"></div>
                    <div className="row mt-3">
                      <div className="data table-responsive">
                        <Table striped bordered hover responsive center>
                          <thead>
                            <tr className="">
                              <th>
                                <input
                                  type="checkbox"
                                  value="selectAll"
                                  checked={
                                    allChecked.length ===
                                    selectAllChecked.length
                                  }
                                  onChange={handleChange}
                                  id="selectAll"
                                  className="me-1"
                                ></input>
                                Select
                              </th>
                              {visible.col1 && <th className="sr">Sr. No.</th>}
                              {visible.col2 && (
                                <th className="tax-name">Invoice Number </th>
                              )}{" "}
                              {visible.col3 && (
                                <th className="tax-name">Customer name </th>
                              )}
                              {visible.col7 && (
                                <th className="tax-name">Paid Amount</th>
                              )}{" "}
                              {visible.col8 && (
                                <th className="tax-name">Payment Mode</th>
                              )}{" "}
                              {visible.col9 && (
                                <th className="tax-name">Order Status</th>
                              )}{" "}
                              {visible.col10 && (
                                <th className="tax-name">Order ID</th>
                              )}{" "}
                              {visible.col11 && (
                                <th className="tax-name">
                                  Order Transaction ID
                                </th>
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {data?.data?.data?.length > 0 ? (
                              data.data.data.map((d, index) => {
                                const paginatedIndex =
                                  (onPageChange - 1) * perPage + index + 1;
                                return (
                                  <tr className="" key={index}>
                                    {" "}
                                    <td>
                                      {/* {(d.order_status_id === 1 ||
                                  d.order_status_id === 2 ||
                                  d.order_status_id === 3) && ( */}
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        value={d?.id}
                                        name="perselected"
                                        checked={selectAllChecked.includes(
                                          d?.id
                                        )}
                                        onChange={handleChange}
                                        id="flexCheckDefault"
                                      />
                                      {/* )} */}
                                    </td>
                                    {visible.col1 && <td>{paginatedIndex}.</td>}{" "}
                                     {visible.col2 && (
                                       <td>
                                         {d?.orders_detail?.invoice ||
                                         d?.orders_detail?.order?.invoice ? (
                                           <a
                                             href={
                                               (
                                                 d?.orders_detail?.invoice ||
                                                 d?.orders_detail?.order?.invoice
                                               )?.startsWith("http")
                                                 ? d?.orders_detail?.invoice ||
                                                   d?.orders_detail?.order?.invoice
                                                 : `${IMG_URL}/${(
                                                     d?.orders_detail?.invoice ||
                                                     d?.orders_detail?.order?.invoice
                                                   ).replace(/^\/+/, "")}`
                                             }
                                             target="_blank"
                                             rel="noopener noreferrer"
                                             style={{
                                               color: "#0d6efd",
                                               textDecoration: "underline",
                                               fontWeight: "500",
                                               cursor: "pointer",
                                             }}
                                           >
                                             {d?.orders_detail?.invoice_no ||
                                               d?.invoice_no ||
                                               "Invoice"}
                                           </a>
                                         ) : (
                                           d?.orders_detail?.invoice_no ||
                                           d?.invoice_no ||
                                           "-"
                                         )}
                                       </td>
                                     )}
                                    {visible.col3 && (
                                      <td>{d?.user?.first_name}</td>
                                    )}{" "}
                                    {visible.col7 && (
                                      <td>
                                        ₹{" "}
                                        {(
                                          (Number(d?.orders_detail?.price) ||
                                            0) *
                                            (Number(
                                              d?.orders_detail?.quantity
                                            ) || 1) -
                                          (Number(
                                            d?.orders_detail?.membershipDiscount
                                          ) || 0) +
                                          (Number(
                                            d?.orders_detail?.delivery_charges
                                          ) || 0) -
                                          (Number(d?.orders_detail?.discount) ||
                                            0) +
                                          (Number(
                                            d?.orders_detail?.quick_delivery_charges
                                          ) || 0)
                                        ).toFixed(2)}
                                      </td>
                                    )}{" "}
                                    {visible.col8 && <td>{d?.payment_mode}</td>}{" "}
                                    {visible.col9 && (
                                      <td>
                                        {
                                          d?.orders_detail?.order_status
                                            ?.order_status
                                        }
                                      </td>
                                    )}{" "}
                                    {visible.col10 && (
                                      <td>{d?.orders_detail?.id}</td>
                                    )}{" "}
                                    {visible.col11 && (
                                      <td>
                                        {d?.orders_detail?.order
                                          ?.transaction_id || "-"}
                                      </td>
                                    )}{" "}
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td colSpan="10" className="text-center">
                                  Data not available
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>{" "}
                        <Pagination_Holder
                          onPageChange={currentPage}
                          totalPages={totalPages}
                          handlePageChange={handlePageChange}
                        />
                        {/*  <table id="example" className="display" style={{ width: '100%' }}>
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Position</th>
                            <th>Office</th>
                            {/* <th>Age</th>
                            <th>Start date</th>
                            <th>Salary</th>
                          </tr>
                        </thead>
                        <tbody>
                          {datanew.map((item, index) => (
                            <tr key={index}>
                              <td>{item.Name}</td>
                              <td>{item.Position}</td>
                              <td>{item.Office}</td>
                              {/* <td>{item.Age}</td>
                              <td>{item.StartDate}</td> 
                              <td>{item.Salary}</td>
                            </tr>
                          ))}
                        </tbody>

                      </table>*/}
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* {show ? (
        <AddOffCanvance
          handleClose={handleClose}
          setShow={setShowAdd}
          show={show}
        />
      ) : (
        ""
      )}

      {show1 ? (
        <EditOffCanvance
          handleClose={handleClose1}
          setShow={setShowEdit}
          show={show1}
        />
      ) : (
        ""
      )} */}

      <ModalDelete
        show={showDeleteModal}
        handleDeleteRecord={handleDeleteRecord}
        handleDeleteCancel={handleDeleteCancel}
      />

      <ModelBulkUpload
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
      <Toaster position="top-right" />

      <OffcanvasCon show={showoff} handleClose={() => setShowoff(false)} />
    </>
  );
};

export default Tables;
